<template>
    <div class="py-4">
        <h4 class="text-center font-active"> Wedding {{ $t('jewelry') }} For Your Big Day </h4>
        <div class="row mt-4 pt-3">
            <div class="col-md-3 col-6 text-center">
            <NuxtLink :to="localePath({ name: 'shop-earring'})">
              <picture>
                <source width="278" height="278" type="image/webp" srcset="~/assets/landing/wedding/popular/stud.webp">
                <img class="radious_eight" loading="lazy" alt="Stud Earrings" width="278" height="278" src="~/assets/landing/wedding/popular/stud.jpg">
              </picture>
              <h6 class="mb-0">Stud Earrings <span>Classic wedding day earrings.</span></h6>
            </NuxtLink>
            </div>          
            <div class="col-md-3 col-6 text-center">
            <NuxtLink :to="localePath({ name: 'shop-bracelet'})">
                <picture>
                <source width="278" height="278" type="image/webp" srcset="~/assets/landing/wedding/popular/tennis.webp">
                <img class="radious_eight" loading="lazy" alt="Tennis Bracelets" width="278" height="278" type="image/jpeg" src="~/assets/landing/wedding/popular/tennis.jpg">
                </picture>
                <h6 class="mb-0">Tennis Bracelets<span>Sparkling bridal {{ $t('jewelry') }} bracelets.</span></h6>
            </NuxtLink>
            </div>          
            <div class="col-md-3 col-6 text-center">
            <NuxtLink :to="localePath({ name: 'shop-tennis-necklace'})">
                <picture>
                <source width="278" height="278" type="image/webp" srcset="~/assets/landing/wedding/popular/necklase.webp">
                <img class="radious_eight" loading="lazy" alt="Tennis Necklaces" width="278" height="278" type="image/jpeg" src="~/assets/landing/wedding/popular/necklase.jpg">
                </picture>
                <h6 class="mb-0">Tennis Necklaces<span>Contemporary single-line diamond necklaces.</span></h6>
            </NuxtLink>
            </div>          
            <div class="col-md-3 col-6 text-center">
            <NuxtLink :to="localePath({ name: 'shop-solitaire-necklace'})">
                <picture>
                <source width="278" height="278" type="image/webp" srcset="~/assets/landing/wedding/popular/pendant.webp">
                <img class="radious_eight" loading="lazy" alt="Solitaire Pendants" width="278" height="278" type="image/jpeg" src="~/assets/landing/wedding/popular/pendant.jpg">
                </picture>
                <h6 class="mb-0">Solitaire Pendants<span>Timeless solitaire diamond pendants.</span></h6>
            </NuxtLink>
        </div>          
        </div>  
    </div>

</template>

<script setup>
    const localePath = useLocalePath()
</script>

<style scoped>

h4{
    font-size: 32px;
    text-transform: capitalize;
}
a{
    color: #000;
    display: inline-block;
} 
span{
    display: block;
    text-align: center;
  
    padding-top: 4%;
    font-weight: 400;
}
h6 {
    font-weight: 600;
    font-size: 16px;
    padding-top: 8%;
}
@media(max-width: 992px){
    h4{
        font-size: 24px;
    }
}
@media(max-width: 767px){
   
    a{
        margin-bottom: 12%;
    }
    h6 {
        font-size: 14px;
    }
}
</style>